import { render } from "./ApiSalesforce.html?vue&type=template&id=486a3e42&external"
import script from "./ApiSalesforce.vue?vue&type=script&lang=js"
export * from "./ApiSalesforce.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__